import { toThemePixels } from '@/utils'
import styled from 'styled-components'
import { Row } from '../../styled'

export const AddButtonContainer = styled(Row)`
  margin-top: ${toThemePixels(8)};
  width: 100%;

  & > button {
    width: 100%;
  }
`
